(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-colorway-posters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('db-colorway-posters')) {
    customElements.define('db-colorway-posters', class extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[data-colorway-tabs]');
        if (!this.tablist) return;
        this.tabs = [...this.querySelectorAll('[data-colorway-tab]')];
        this.panels = [...this.querySelectorAll('[data-colorway-panel]')];
        this.onClick = (event) => {
          const tab = event.target.closest('[data-colorway-tab]');
          if (tab && this.tablist.contains(tab)) this.activate(this.tabs.indexOf(tab));
        };
        this.onKeydown = (event) => {
          const current = this.tabs.indexOf(event.target);
          if (current < 0) return;
          let next;
          switch (event.key) {
            case 'ArrowRight': next = (current + 1) % this.tabs.length; break;
            case 'ArrowLeft': next = (current - 1 + this.tabs.length) % this.tabs.length; break;
            case 'Home': next = 0; break;
            case 'End': next = this.tabs.length - 1; break;
            default: return;
          }
          event.preventDefault();
          this.activate(next, true);
        };
        this.onBlockSelect = (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.activate(index);
        };
        this.tablist.addEventListener('click', this.onClick);
        this.tablist.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.tablist) {
          this.tablist.removeEventListener('click', this.onClick);
          this.tablist.removeEventListener('keydown', this.onKeydown);
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      activate(index, focus = false) {
        if (index < 0 || index >= this.tabs.length) return;
        this.classList.add('db-colorway-posters--animate');
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-support-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-db-support-center]';
    const sourceSelector = [
      'a.db-support-card',
      'a.db-support-topic',
      'a.db-support-service',
      'a.db-support-popular',
      'a.db-support-contact-card'
    ].join(',');
    const titleSelector = [
      '.db-support-card__title',
      '.db-support-topic__copy strong',
      '.db-support-service__copy strong',
      '.db-support-popular__title',
      '.db-support-contact-card__copy strong'
    ].join(',');
    const descriptionSelector = [
      '.db-support-card__description',
      '.db-support-topic__copy small',
      '.db-support-service__copy small',
      '.db-support-contact-card__copy small'
    ].join(',');

    const normalizeText = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim();

    const appendHighlightedText = (element, value, query) => {
      const cleanQuery = query.trim();

      if (!cleanQuery) {
        element.textContent = value;
        return;
      }

      const escapedQuery = cleanQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const matcher = new RegExp(`(${escapedQuery})`, 'gi');
      const parts = value.split(matcher);

      parts.forEach((part, index) => {
        if (index % 2 === 1) {
          const mark = document.createElement('mark');
          mark.textContent = part;
          element.append(mark);
        } else if (part) {
          element.append(document.createTextNode(part));
        }
      });
    };

    class SupportCenterSearch {
      constructor(root) {
        if (root.dataset.dbSupportSearchReady === 'true') return;

        this.root = root;
        this.form = root.querySelector('[data-db-support-search-form]');
        this.input = this.form?.querySelector('input[type="search"]');
        this.results = root.querySelector('[data-db-support-search-results]');
        this.list = root.querySelector('[data-db-support-search-list]');
        this.status = root.querySelector('[data-db-support-search-status]');
        this.empty = root.querySelector('[data-db-support-search-empty]');
        this.countLabel = root.dataset.searchCountLabel || 'search results';
        this.searchTimer = null;

        if (!this.form || !this.input || !this.results || !this.list || !this.status || !this.empty) return;

        this.items = this.collectItems();
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        root.dataset.dbSupportSearchReady = 'true';

        const initialQuery = new URLSearchParams(window.location.search).get('support_q');
        if (initialQuery) {
          this.input.value = initialQuery;
          this.render(initialQuery, false);
        }
      }

      collectItems() {
        const seen = new Set();

        return Array.from(this.root.querySelectorAll(sourceSelector)).reduce((items, source, index) => {
          const title = source.querySelector(titleSelector)?.textContent.trim() || '';
          const description = source.querySelector(descriptionSelector)?.textContent.trim() || '';
          const groupContainer = source.closest('.db-support-center__group, .db-support-contact');
          const group = groupContainer?.querySelector('.db-support-center__kicker')?.textContent.trim() || '';
          const href = source.getAttribute('href') || '';
          const keywords = source.textContent.trim();

          if (!title || !href) return items;

          const key = `${new URL(href, window.location.href).href}|${normalizeText(title)}`;
          if (seen.has(key)) return items;
          seen.add(key);

          items.push({
            title,
            description,
            group,
            href,
            target: source.getAttribute('target') || '',
            keywords,
            index,
            normalizedTitle: normalizeText(title),
            normalizedText: normalizeText(`${title} ${description} ${group} ${keywords}`)
          });

          return items;
        }, []);
      }

      onInput() {
        window.clearTimeout(this.searchTimer);
        const query = this.input.value.trim();

        if (!query) {
          this.close();
          return;
        }

        this.searchTimer = window.setTimeout(() => this.render(query, false), 140);
      }

      onSubmit(event) {
        event.preventDefault();
        const query = this.input.value.trim();

        if (!query) {
          this.close();
          this.input.focus();
          return;
        }

        this.render(query, true);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        this.input.value = '';
        this.close();
      }

      render(query, shouldScroll) {
        const normalizedQuery = normalizeText(query);
        if (!normalizedQuery) {
          this.close();
          return;
        }

        const tokens = normalizedQuery.split(' ').filter(Boolean);

        const matches = this.items
          .filter((item) => tokens.every((token) => item.normalizedText.includes(token)))
          .map((item) => {
            let score = 4;
            if (item.normalizedTitle === normalizedQuery) score = 0;
            else if (item.normalizedTitle.startsWith(normalizedQuery)) score = 1;
            else if (item.normalizedTitle.includes(normalizedQuery)) score = 2;
            else if (item.normalizedText.includes(normalizedQuery)) score = 3;

            return { item, score };
          })
          .sort((a, b) => a.score - b.score || a.item.index - b.item.index)
          .map((match) => match.item);

        this.list.replaceChildren();
        matches.forEach((item) => this.list.append(this.createResult(item, query)));

        const hasResults = matches.length > 0;
        this.empty.hidden = hasResults;
        this.status.textContent = `${matches.length} ${this.countLabel}`;
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');

        if (shouldScroll) {
          this.results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      createResult(item, query) {
        const wrapper = document.createElement('div');
        const link = document.createElement('a');
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        const arrow = document.createElement('span');

        wrapper.className = 'db-support-search-result-item';
        wrapper.setAttribute('role', 'listitem');
        link.className = 'db-support-search-result';
        link.href = item.href;

        if (item.target === '_blank') {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }

        copy.className = 'db-support-search-result__copy';
        title.className = 'db-support-search-result__title';
        appendHighlightedText(title, item.title, query);

        if (item.group) {
          const group = document.createElement('span');
          group.className = 'db-support-search-result__group';
          group.textContent = item.group;
          copy.append(group);
        }

        copy.append(title);

        if (item.description) {
          const description = document.createElement('span');
          description.className = 'db-support-search-result__description';
          appendHighlightedText(description, item.description, query);
          copy.append(description);
        }

        arrow.className = 'db-support-search-result__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.append(copy, arrow);
        wrapper.append(link);

        return wrapper;
      }

      close() {
        window.clearTimeout(this.searchTimer);
        this.results.hidden = true;
        this.list.replaceChildren();
        this.status.textContent = '';
        this.empty.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
      }
    }

    const initialize = (scope) => {
      if (scope.matches?.(rootSelector)) new SupportCenterSearch(scope);
      scope.querySelectorAll?.(rootSelector).forEach((root) => new SupportCenterSearch(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
